module.exports = __webpack_public_path__ + "img/exercicios.d814cc1a.jpg";